import { Link } from 'react-router-dom';

export default function ExperienciasComplementaresPlanos() {
  const produtos = [
    {
      id: 'diario-eu-futuro',
      icon: 'ri-book-open-line',
      emoji: '📖',
      titulo: 'Diário do Eu do Futuro',
      precoRange: 'R$ 147',
      descricao: 'Espaço digital para reflexões contínuas, registro de metas e acompanhamento da sua evolução pessoal.',
      beneficios: [
        'Espaço para reflexões contínuas',
        'Registro de metas e conquistas',
        'Revisão periódica da evolução'
      ],
      cor: '#8B5CF6',
      meditacaoLink: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+autoconhecimento+reflex%C3%A3o+diario',
      meditacaoTitulo: 'Meditação para Autoconhecimento'
    },
    {
      id: 'audios-premium',
      icon: 'ri-headphone-line',
      emoji: '🎧',
      titulo: 'Áudios Premium de Reprogramação',
      precoRange: 'R$ 197',
      descricao: 'Biblioteca completa de áudios para motivação diária, foco, disciplina e redução da ansiedade.',
      beneficios: [
        'Motivação diária',
        'Foco e disciplina',
        'Autoconfiança',
        'Redução da ansiedade'
      ],
      cor: '#0D9488',
      meditacaoLink: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+reprograma%C3%A7%C3%A3o+mental+foco+disciplina',
      meditacaoTitulo: 'Meditação de Reprogramação Mental'
    },
    {
      id: 'kit-fisico-premium',
      icon: 'ri-gift-line',
      emoji: '📦',
      titulo: 'Kit Físico Premium',
      precoRange: 'R$ 397',
      descricao: 'Receba sua carta impressa em papel especial, envelope selado e embalagem elegante para uma experiência sensorial única.',
      beneficios: [
        'Carta impressa em papel especial',
        'Envelope selado',
        'Embalagem elegante',
        'Experiência sensorial'
      ],
      cor: '#D97706',
      meditacaoLink: '',
      meditacaoTitulo: ''
    }
  ];

  return (
    <section className="py-24 bg-luxury-dark relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent via-gold-500/[0.02] to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gold-500/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
              💌 Experiências Complementares
            </span>
            <div className="w-12 h-px bg-gold-500/40"></div>
          </div>
          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-white mb-4">
            Potencialize Sua <span className="text-gold-400 italic">Transformação</span>
          </h2>
          <p className="font-['Montserrat'] text-lg text-white/60 max-w-2xl mx-auto leading-relaxed">
            Ferramentas exclusivas para aprofundar sua jornada de autoconhecimento
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {produtos.map((p) => (
            <div
              key={p.id}
              className="bg-white/[0.03] rounded-2xl border border-gold-500/10 hover:border-gold-500/30 p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(201,168,76,0.08)]"
            >
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center mb-5"
                style={{ backgroundColor: `${p.cor}20` }}
              >
                <i className={`${p.icon} text-2xl`} style={{ color: p.cor }}></i>
              </div>

              <h3 className="font-['Playfair_Display'] text-xl font-semibold text-white mb-2">
                {p.emoji} {p.titulo}
              </h3>

              <p className="font-['Montserrat'] text-base text-white/60 mb-5 leading-relaxed">
                {p.descricao}
              </p>

              <div className="mb-5 pb-5 border-b border-gold-500/10">
                <span className="font-['Playfair_Display'] text-2xl font-bold text-gold-400">
                  {p.precoRange}
                </span>
              </div>

              <ul className="space-y-3 mb-5">
                {p.beneficios.map((b, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ backgroundColor: `${p.cor}20` }}>
                      <i className="ri-check-line text-xs" style={{ color: p.cor }}></i>
                    </div>
                    <span className="font-['Montserrat'] text-sm text-white/70">{b}</span>
                  </li>
                ))}
              </ul>

              {/* Meditação Link */}
              {p.meditacaoLink && (
                <a
                  href={p.meditacaoLink}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-2 mb-5 px-3 py-2 bg-white/[0.03] rounded-lg border border-gold-500/10 hover:border-gold-500/30 transition-all cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-youtube-fill text-lg text-red-500"></i>
                  </div>
                  <span className="font-['Montserrat'] text-xs text-white/50 hover:text-gold-400 transition-colors truncate">
                    {p.meditacaoTitulo}
                  </span>
                  <i className="ri-external-link-line text-xs text-white/30 ml-auto flex-shrink-0"></i>
                </a>
              )}

              <Link
                to={`/experiencia/${p.id}`}
                className="block w-full py-3 rounded-lg font-['Montserrat'] font-semibold text-sm text-white transition-all whitespace-nowrap cursor-pointer text-center hover:opacity-90"
                style={{ backgroundColor: p.cor }}
              >
                Ver Detalhes
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
